import loadable from '@loadable/component';

export const OrgDashboardPreviewOrgPageContainerLoadable = loadable(
  () => import('./OrgDashboardPreviewOrgPageContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardPreviewOrgPageContainer,
  },
);
